import api from "./api";

export const getApps = () => api.get("/apps").then(r => r.data);
export const toggleAppFeature = (key, toggle, value) =>
  api.post(`/apps/${key}/toggle`, { toggle, value }).then(r => r.data);

export const getMessages = (app_key) =>
  api.get("/messages", { params: app_key ? { app_key } : {} }).then(r => r.data);
export const readMessage = (mid) => api.post(`/messages/${mid}/read`).then(r => r.data);

export const getSales = (app_key = "clothing", hours = 24) =>
  api.get("/sales", { params: { app_key, hours } }).then(r => r.data);

export const getWeather = (location = "London") =>
  api.get("/weather", { params: { location } }).then(r => r.data);

export const getTasks = (hours = 24) =>
  api.get("/tasks", { params: { hours } }).then(r => r.data);

export const runScan = () => api.post("/jarvis/scan").then(r => r.data);
